<template>
  <div class="vld-parent">
    
    
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-lg-6 style-paper">
        <div style="text-align: center;">
          <h4>Monthly Income</h4>
        </div>
        <table cellspacing="0" cellpadding="0" border="0" class="el-table">
          <thead class="has-gutter">
            <tr class="text-primary">
              <th class="incomeHeader">Month</th>
              <th class="incomeHeader">Projects</th>
              <th class="incomeHeader">Hours</th>
              <th class="incomeHeader">Income</th>
              <th class="incomeHeader">Effective<br/>Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(income,index) in incomeData" :key="income.id">
              <td style="text-align: center">{{income.observation_month}}</td>
              <td style="text-align: center">{{income.projects}}</td>
              <td style="text-align: center">{{income.hours}}</td>
              <td style="text-align: center">${{income.total_income.toLocaleString()}}</td>
              <td style="text-align: center">${{(income.total_income / income.hours).toFixed(2)}}</td>
              
              <td style="width: 40px; height:50px;text-align:center;">
                <button @click="deleteIncome(index)" type="button" class="btn btn-icon btn-danger btn-sm"><i class="fa fa-times"></i></button>
              </td>
              <td></td>
            </tr>
            <tr class="last-row">
              <td>
                <div class="input-field text-left">
                  <select class="text-primary plan-projects-select" v-model="input.month">
                    <option value="2018-09-02">September, 2018</option>
                    <option selected value="2018-10-02">October, 2018</option>
                  </select>
                </div>
              </td>
              <td style="width: 100px">
                <div class="input-field">
                  <input class="form-control col-lg-10"  ref="projects" placeholder="Projects" v-model="input.projects" id="projects" type="text">
                </div>
              </td>
              <td style="width: 100px">
                <div class="input-field">
                  <input class="form-control col-lg-9"  ref="hours" placeholder="Hours" v-model="input.hours" id="hours" type="text">
                </div>
              </td>
              <td colspan="2" style="width: 140px">
                <div class="input-field">
                  <input class="form-control col-lg-7"  ref="income" placeholder="Income" v-model="input.income" id="income" type="text">
                </div>
              </td>
              <td colspan="2">
                <a  @click="add" class="btn btn-success add-btn"><i class="fa fa-plus"/> Add </a>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <!-- projections chart -->
      <div v-if="chartData.length > 0" class="col-lg-5 style-paper text-center chart-cont">
        <div style="text-align: center;">
          <h4>Cumulative Increased Earnings Over Time</h4>
        </div>
        <line-chart :data="chartData" :dataset="{borderWidth:1}" :curve="false" :colors="['#51cbce', '#ef8157', '#6bd098','#66615b', '#cac4ae']" ></line-chart>
      </div>
    </div>

    <!-- projections table -->
      <div v-if="chartData.length > 0" class="row">
        <div class="col-lg-6 style-paper">
          <div style="text-align: center;">
            <h4>Yearly Projections</h4>
          </div>
          <table cellspacing="0" cellpadding="0" border="0" class="el-table">
            <thead class="has-gutter">
              <tr><th></th><th class="text-primary money" v-for="column in projectionsData.years" :key="column.id">{{column}}</th></tr>
            </thead>
            <tbody>

              <tr v-for="(projection, id) in projectionsData.data"  :key="projection.id" :class="[projectionsData.data.length === id + 1 ? 'last-row' : '']">
                <td v-if="projection.scenario != 'Difference'">{{projection.scenario}}</td>
                <th class="money difference" v-if="projection.scenario == 'Difference'">{{projection.scenario}}</th>
                <td class="money difference" v-for="(totalincome) in projection.totalincomes"  :key="totalincome.id">
                  <strong v-if="projection.scenario == 'Difference'">${{totalincome.toLocaleString()}}</strong>
                  <span v-if="projection.scenario != 'Difference'">${{totalincome.toLocaleString()}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    <modal :show.sync="showModal"
           footer-classes="justify-content-center"
           type="notice">
      <h5 slot="header" class="modal-title">How Do You Use This Screen?</h5>
      <template>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>Enter last month's hours and earnings</strong>
              <p class="description">Your Effective Rate feeds the rest of the planning process.  Enter last month's
              projects, hours, and earnings - we'll calculate your effective rate using that tricky math operation known
              as "division". Don't worry if the values aren't exact - just enter your best estimate.</p>
            </div>
          </div>
        </div>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>But, wait, there's more!</strong>
              <p class="description"> We'll show you a few growth scenarios and how much more you
                can earn over the next 5 years - that uses both multiplication <em>and</em> subtraction.  Good thing
              we have all these servers!</p>
            </div>
          </div>
        </div>
      </template>
      <div slot="footer" class="justify-content-center">
        <p-button type="info" round @click.native="showModal = false">Got it!</p-button>
      </div>
    </modal>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";

import { mapActions } from 'vuex';
import { Auth, Analytics } from "aws-amplify";

import {
  getProjectionsAPI,
  getMonthlyIncomeAPI,
  addIncomeAPI,
  updateIncomeAPI,
  deleteIncomeAPI
} from "./../../api/api";
import Loading from "vue-loading-overlay";
import Datepicker from "vuejs-datepicker";
import VueChartkick from "vue-chartkick";
import Chart from "chart.js";
import Vue from "vue";
Vue.use(VueChartkick, { adapter: Chart });
import "vue-loading-overlay/dist/vue-loading.css";
import Modal from "../UIComponents/Modal"

export default {
  components: {
    Loading,
    Datepicker,
    Modal
  },

  async beforeCreate() {
    try {
      this.account = await Auth.currentAuthenticatedUser();
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", async info => {
      if (info === "signedIn") {
        this.signedIn = true;
        this.account = await Auth.currentAuthenticatedUser();
      } else {
        this.signedIn = false;
      }
    });
  },
  created() {
    this.setNavbarTitle('Income');
  },
  mounted() {
    this.getIncome();
    this.getProjections();
  },

  data() {
    return {
      showModal:false,
      isLoading: false,
      fullPage: true,
      incomeData: {},
      projectionsData: {},
      yearCols: {},
      columns: ["Month", "Projects", "Hours", "Income", "Effective Rate", ""],

      input: {
        month: "2018-10-02",
        projects: "",
        hours: "",
        income: ""
      },
      editInput: {
        month: "",
        projects: "",
        hours: "",
        income: ""
      },

      chartData: []
    };
  },

  methods: {
    ...mapActions('UI', ['setNavbarTitle']),
    
    getProjections() {
      getProjectionsAPI().then(data => {
        let projectionArray = data;
        if (projectionArray.length > 0) {
          let years = Object.keys(projectionArray[0]);
          years.shift();
          years.pop();
          this.projectionsData.years = years;

          let data = []
          this.chartData = []
          for (var i=0; i<projectionArray.length; i++) {
            let projects = projectionArray[i]
            let keys     = Object.keys(projects)
            let values   = Object.values(projects)
            values.shift()
            values.pop()
            let projection          = {}
            projection.scenario     = projects.scenario
            projection.totalincomes = values
            projection.footnote     = projects.footnote
            
            data.push(projection)

            //add chart data
            let chartitem = {}
            chartitem.name = projects.scenario
            chartitem.data = {}
            let firstTotalIncome = data[0].totalincomes
            for (var j=0; j< this.projectionsData.years.length; j++) {
                for (var b=0; b< values.length; b++) {
                  let income      = values[j]
                  let firstincome = firstTotalIncome[j]
                  var dif         = income - firstincome
                }
                if(i != 0){
                  chartitem.data[this.projectionsData.years[j].replace(/\s/g, '') ] = dif;
                }
            }
            this.chartData.push(chartitem)
            // add difference and empty row
            if (i == 0) {
              /*data.push({})*/
            }else {
              let firstTotalIncome = data[0].totalincomes
              let difference = []
              for (var j=0; j< values.length; j++) {
                let income      = values[j]
                let firstincome = firstTotalIncome[j]
                difference.push(income - firstincome)
              }

              let projection = {}
              projection.scenario = "Difference"
              projection.totalincomes = difference
              projection.footnote = ""
              
              data.push(projection)
              /*data.push({})*/
            }
          }
          this.projectionsData.data = data;
        }
        this.isLoading = false;
      });
    },
    getIncome() {
      this.isLoading = true;
      getMonthlyIncomeAPI().then(data => {
        this.incomeData = data;
        this.isLoading = false;
        if (data.length == 0) {
          this.showModal = true;
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },
    getDateFromObservationMonth(month) {
      let newDateArray = month.split('-');
      let newDate = new Date(parseInt(newDateArray[0]), parseInt(newDateArray[1])-1, parseInt(newDateArray[2]));
      return newDate;
    },

    add: function() {
      if (this.input.month === "") {
        return;
      }

      if (this.input.projects === "") {
        this.$refs.projects.focus();
        return;
      }

      if (this.input.hours === "") {
        this.$refs.hours.focus();
        return;
      }

      if (this.input.income === "") {
        this.$refs.income.focus();
        return;
      }

      let deleteExisting = false;
      let existingIndex = -1;
      for (let i=0;i < this.incomeData.length;i++){
        let existingIncome = this.incomeData[i];
        let existingDate = this.getDateFromObservationMonth(existingIncome.observation_month);
        let addDate = this.getDateFromObservationMonth(this.input.month);

        if (existingDate.getFullYear() == addDate.getFullYear() && existingDate.getMonth() == addDate.getMonth()){
          deleteExisting = true;
          existingIndex = i;
        }

      }

      let newIncome = {
        "projects": parseInt(this.input.projects),
        "hours": parseFloat(this.input.hours),
        "total_income": parseFloat(this.input.income),
        "observation_month": this.input.month
      };

      if (deleteExisting) {
        this.deleteIncome(existingIndex);
      } else {
        setTimeout(this.getProjections, 1500);
      }

      this.incomeData.push(newIncome);
      addIncomeAPI(newIncome).then(() => {
        this.getIncome();
      });

      for (var key in this.input) {
        this.input[key] = "";
      }
      this.$refs.projects.focus();
      Analytics.record({ name: 'plan income add month' })
    },
    deleteIncome: function(index) {
      let id = this.incomeData[index].entity_id
      this.incomeData.splice(index, 1);
      deleteIncomeAPI(id).then(() => {
        this.projectionsData = {};
        this.chartData = [];
        setTimeout(this.getProjections, 1500);
      })
      Analytics.record({ name: 'plan income delete month' })
    }
  }
};
</script>

<style lang="scss">
.el-table .last-row td {
  border-bottom: none;
}
.vdp-datepicker__calendar {
  position: fixed;
  display: block;
}
.vdp-datepicker__calendar-button {
  position: absolute;
  display: block;
  padding: 5px;
  float: right;
  right: 32px;
}
</style>

<style scoped>
    .style-paper {
      -moz-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
      -ms-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
      -o-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
      -webkit-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
      background-color: #fff;
      border: 0;
      border-radius: 3px;
      box-shadow: 0 6px 10px -4px rgba(0,0,0,.15);
      color: #252422;
      margin: 0px;
      margin-bottom: 20px;
      position: relative;
      transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
  }
  .add-btn {
    color: white !important;
  }
  .chart-cont {
    margin-left: 20px;
  }
  #projects {
    margin-left: 3px;
  }
  .money {
    text-align: right;
  }
  .incomeHeader {
    text-align: center;
    vertical-align: bottom;
  }
  .difference {
    color: #2c2c2c;
  }
</style>
